import { Link } from 'react-router-dom';
import PortalLayout from '@/components/feature/PortalLayout';
import MovieCard from '@/components/feature/MovieCard';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import { movies } from '@/mocks/movies';

const latest = [...movies].sort((a, b) => b.releaseDate.localeCompare(a.releaseDate)).slice(0, 8);
const hot = [...movies].sort((a, b) => b.heat - a.heat).slice(0, 8);

const categoryEntries = [
  {
    title: '电影专区',
    desc: '院线新片、经典佳作，按类型与年份快速筛选',
    to: '/category/movie',
    count: movies.filter((m) => m.type === 'movie').length,
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%2C%20dramatic%20action%20movie%20scene%20with%20city%20night%20lights%20and%20car%20chase%2C%20orange%20and%20teal%20cinematic%20palette%2C%20no%20text&width=800&height=450&seq=cat-movie-entry&orientation=landscape',
  },
  {
    title: '电视剧专区',
    desc: '口碑剧集、热播连载，追剧不再错过好内容',
    to: '/category/tv',
    count: movies.filter((m) => m.type === 'tv').length,
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20still%2C%20cozy%20living%20room%20with%20soft%20screen%20glow%20and%20warm%20lamp%20light%2C%20family%20watching%20together%20at%20night%2C%20warm%20tones%2C%20no%20text&width=800&height=450&seq=cat-tv-entry&orientation=landscape',
  },
];

export default function Home() {
  return (
    <PortalLayout>
      <HeroCarousel />

      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* category entries */}
        <section className="grid grid-cols-1 md:grid-cols-2 gap-5 -mt-10 relative z-20">
          {categoryEntries.map((cat) => (
            <Link
              key={cat.to}
              to={cat.to}
              className="group relative h-44 md:h-52 rounded-lg overflow-hidden border border-background-200 cursor-pointer"
            >
              <img
                src={cat.image}
                alt={cat.title}
                title={`${cat.title} - 诱人的女员工hd影视专区`}
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/70 to-primary-950/30"></div>
              <div className="relative z-10 h-full flex flex-col justify-center px-6">
                <h2 className="font-heading font-black text-background-50 text-xl md:text-2xl">
                  {cat.title}
                </h2>
                <p className="mt-2 text-sm text-background-200 max-w-xs">{cat.desc}</p>
                <span className="mt-4 inline-flex items-center gap-1 text-accent-400 text-sm font-medium">
                  共 {cat.count} 部作品
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </section>

        {/* latest */}
        <section className="mt-14">
          <div className="flex items-end justify-between mb-5">
            <div>
              <h2 className="font-heading font-black text-foreground-950 text-2xl">最新影视推荐</h2>
              <p className="text-sm text-foreground-500 mt-1">按发布时间整理，第一时间了解最新收录作品</p>
            </div>
            <Link to="/category/movie" className="hidden sm:inline-flex items-center gap-1 text-sm text-accent-600 hover:text-accent-700 whitespace-nowrap cursor-pointer">
              查看更多<i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {latest.map((m) => (
              <MovieCard key={m.id} movie={m} />
            ))}
          </div>
        </section>

        {/* hot ranking */}
        <section className="mt-14 bg-background-100 border border-background-200 rounded-lg p-5 md:p-8">
          <div className="flex items-end justify-between mb-5">
            <div>
              <h2 className="font-heading font-black text-foreground-950 text-2xl">热门影视作品榜单</h2>
              <p className="text-sm text-foreground-500 mt-1">根据点击与用户偏好综合排序</p>
            </div>
            <Link to="/search" className="hidden sm:inline-flex items-center gap-1 text-sm text-accent-600 hover:text-accent-700 whitespace-nowrap cursor-pointer">
              去搜索<i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-y-1">
            {hot.map((m, i) => (
              <Link
                key={m.id}
                to={`/detail/${m.id}`}
                className="group flex items-center gap-3 py-3 border-b border-background-200 last:border-0 cursor-pointer"
              >
                <span
                  className={`w-7 h-7 shrink-0 flex items-center justify-center rounded-md text-sm font-bold ${
                    i < 3 ? 'bg-accent-500 text-background-50' : 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {i + 1}
                </span>
                <span className="font-heading font-bold text-foreground-950 group-hover:text-accent-600 transition-colors truncate">
                  {m.title}
                </span>
                <span className="text-xs text-foreground-500 whitespace-nowrap">{m.year} · {m.region}</span>
                <span className="ml-auto text-xs text-foreground-500 whitespace-nowrap">热度 {m.heat}</span>
              </Link>
            ))}
          </div>
        </section>

        {/* intro */}
        <section className="mt-14 bg-primary-950 rounded-lg p-6 md:p-10 text-background-50">
          <h2 className="font-heading font-black text-2xl">关于诱人的女员工hd影视专区</h2>
          <p className="mt-3 text-sm md:text-base text-background-200 leading-relaxed max-w-4xl">
            本站是一个专注于影视作品介绍与推荐的资讯门户，围绕「诱人的女员工hd」相关内容，为用户整理最新电影与电视剧的剧情简介、
            演员阵容与播出信息。我们希望通过清晰的分类、便捷的搜索与贴心的收藏功能，帮助喜爱追剧的你快速了解作品亮点，
            更轻松地选择想看的资源。站内内容仅用于影视资讯展示，不提供在线播放与下载功能。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link to="/about" className="px-5 py-2.5 rounded-md bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer">
              了解我们
            </Link>
            <Link to="/category/tv" className="px-5 py-2.5 rounded-md bg-background-50/15 text-background-50 text-sm font-medium hover:bg-background-50/25 transition-colors whitespace-nowrap cursor-pointer">
              浏览电视剧
            </Link>
          </div>
        </section>
      </div>
    </PortalLayout>
  );
}